import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
  Typography,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import DownloadIcon from '@mui/icons-material/Download';

import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../components/common/Table';
import colors from '../../../assets/colors';
import { downloadCSVFile } from '../../../utils/utils';

export default function AcceptedTable(props) {
  const acceptedTableToCSV = (data) => {
    const { parse } = require('json2csv');
    const fields = [
      { label: 'Imię', value: `name` },
      { label: 'Nazwisko', value: `surname` },
      { label: 'Telefon', value: `phoneNumber` },
      { label: 'E-mail', value: `email` },
      { label: 'Agrowe', value: `agrowePermission` },
      { label: 'Data', value: `agrowePermissionDate` },
      { label: 'Bank', value: `bankPermission` },
      { label: 'Data', value: `bankPermissionDate` },
      { label: 'Przetwarzanie danych', value: `dataProcessingPermission` },
      { label: 'Data', value: `dataProcessingPermissionDate` },
    ];
    const opts = { fields };
    try {
      const csv = parse(data, opts);
      return csv;
    } catch (err) {}
  };

  const handleExport = () => {
    downloadCSVFile(acceptedTableToCSV(props.data));
  };

  return (
    <>
      <Grid container sx={{ my: 8 }}>
        <Grid item xs={12} ref={props.cropsStructureTableRef}>
          <Button variant="text" onClick={handleExport}>
            <DownloadIcon />
            EKSPORTUJ
          </Button>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="acceptedTable">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Imię</StyledTableCell>
                  <StyledTableCell align="center">Nazwisko</StyledTableCell>
                  <StyledTableCell align="center">Telefon</StyledTableCell>
                  <StyledTableCell align="center">E-mail</StyledTableCell>
                  <StyledTableCell align="center">
                    Czy zaakceptowano
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {props.data?.name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.data?.surname}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.data?.phoneNumber}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.data?.email}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.data?.dataProcessingPermission &&
                    props.data?.bankPermission &&
                    props.data?.agrowePermission ? (
                      <DoneIcon sx={{ color: colors.agroweGreen }} />
                    ) : (
                      <CloseIcon sx={{ color: colors.redButton }} />
                    )}
                    {props.data?.dataProcessingPermission &&
                      props.data?.bankPermission &&
                      props.data?.agrowePermission && (
                        <Typography>
                          {props.data?.dataProcessingPermissionDate.join('-')}
                        </Typography>
                      )}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent="right"
          alignContent="right"
        ></Grid>
      </Grid>
    </>
  );
}
